<div class="app-popup-overlay admin-modal-overlay" *ngIf="state" (click)="onOverlayClick()">
  <div class="app-popup admin-modal-panel" (click)="$event.stopPropagation()">
    <div class="app-popup-content">
      <div class="app-popup-head">
        <div class="app-popup-icon-col">
          <div class="app-popup-icon-circle" [attr.data-type]="state?.type">
            <i class="bi" [ngClass]="iconClass"></i>
          </div>
        </div>

        <div class="app-popup-text">
          <div class="app-popup-title">{{ state?.title }}</div>
          <!-- Messages are written as small HTML fragments all over the panel
               (a bolded amount, a PIN on its own line, a <br> before a
               warning), because SwalUtils passed them straight to Swal's
               `html`. Interpolating them printed the tags as text. Angular
               sanitises [innerHTML], so the formatting renders and anything
               dangerous is stripped. -->
          <div class="app-popup-message" *ngIf="state?.message" [innerHTML]="state?.message"></div>
        </div>
      </div>

      <div class="app-popup-actions">
        <button
          class="btn-secondary"
          type="button"
          *ngIf="state?.type === 'confirm'"
          (click)="popup.cancelAction()"
        >
          {{ state?.cancelText || 'Cancel' }}
        </button>

        <button
          class="btn-primary"
          type="button"
          [attr.data-type]="state?.type"
          (click)="state?.type === 'confirm' ? popup.confirmAction() : popup.close(true)"
        >
          {{ state?.confirmText || 'OK' }}
        </button>
      </div>
    </div>
  </div>
</div>
